export const api = {
    data : function () {
        return {
            // In Docker/Portainer the app container proxies /api/ to the admin API container.
            // For local dev, set VUE_APP_API_URL="https://admin.example.com/api/" before building.
            api : process.env.VUE_APP_API_URL || '/api/'
        }
    }
};
